import React from 'react';

const Logo = ({ className = "w-8 h-8", showText = true, textClassName = "text-2xl font-bold text-gray-900" }) => {
  return (
    <div className="flex items-center gap-2">
      <img 
        src="/logo-markeap.png" 
        alt="Markeap" 
        className={className}
      />
      {showText && <span className={textClassName}>Markeap</span>}
    </div>
  );
};

export default Logo;
